import request from '@/utils/request'


// 查询询价记录列表
export function listActivityXunjia(query) {
  return request({
    url: '/activityXunjia/activityXunjia/list',
    method: 'get',
    params: query
  })
}

// 查询询价记录分页
export function pageActivityXunjia(query) {
  return request({
    url: '/activityXunjia/activityXunjia/page',
    method: 'get',
    params: query
  })
}

// 查询询价记录详细
export function getActivityXunjia(data) {
  return request({
    url: '/activityXunjia/activityXunjia/detail',
    method: 'get',
    params: data
  })
}

// 新增询价记录
export function addActivityXunjia(data) {
  return request({
    url: '/activityXunjia/activityXunjia/add',
    method: 'post',
    data: data
  })
}

// 修改询价记录
export function updateActivityXunjia(data) {
  return request({
    url: '/activityXunjia/activityXunjia/edit',
    method: 'post',
    data: data
  })
}

// 删除询价记录
export function delActivityXunjia(data) {
  return request({
    url: '/activityXunjia/activityXunjia/delete',
    method: 'post',
    data: data
  })
}

// 查询询价商品记录分页
export function goodspage(query) {
  return request({
    url: '/activityXunjia/activityXunjia/goodspage',
    method: 'get',
    params: query
  })
}

// 出价
export function chujia(data) {
  return request({
    url: '/activityChujia/activityChujia/chujia',
    method: 'post',
    data: data
  })
}

// 缴纳保证金
export function payBzj(data) {
  return request({
    url: '/activityChujia/activityChujia/payBzj',
    method: 'post',
    data: data
  })
}

// 查询询价报价人记录分页
export function bigpage(query) {
  return request({
    url: '/activityChujia/activityChujia/page',
    method: 'get',
    params: query
  })
}

// 中标
export function zhongbiao(data) {
  return request({
    url: '/activityChujia/activityChujia/zhongbiao',
    method: 'post',
    data: data
  })
}

// 查询询价记录分页
export function pageActivityXunjiacaigou(query) {
  return request({
    url: '/activityXunjia/activityXunjia/pageActivityXunjiacaigou',
    method: 'get',
    params: query
  })
}

// 查询我的报价记录分页
export function mybidpage(query) {
  return request({
    url: '/activityChujia/activityChujia/mybidpage',
    method: 'get',
    params: query
  })
}